export const stepTypes = {
  CLIENT: 'client',
  DATE: 'date',
  HOURS: 'hours',
  CURRENCY: 'currency',
  EXPENSE: 'expense'
};
